export const strings = {
  REQUEST_VOLUNTEERING_SERVICE_SUCCESS: "Created Request for Volunteering Service",
  REQUEST_VOLUNTEERING_SERVICE_ERROR: "Error while creating request!",
  OPPORTUNITY_ACCEPTED_SUCCESS: "Opportunity accepted!",
  OPPORTUNITY_ACCEPTED_ERROR: "Error while accepting opportunity!",
  OPPORTUNITY_DECLINED_SUCCESS: "Opportunity declined!",
  OPPORTUNITY_DECLINED_ERROR: "Error while declining opportunity!",
  VISIT_DETAILS_UPDATED_SUCCESS: "Visit details updated!",
  VISIT_DETAILS_UPDATED_ERROR: "Error while updating visit details!",
  VISIT_STARTED_SUCCESS: "Visit started!",
  VISIT_STARTED_ERROR: "Error while starting visit!",
  FORM_SUBMITTED_SUCCESS: "Form submitted successfully!",
  FORM_UPPDATED_SUCCESS: "Form updated successfully!",
  FORM_SAVED_SUCCESS: "Form saved successfully!",
  FORM_SUBMITTED_ERROR: "Error while submitting form!",
  VISIT_APPROVED_SUCCESS: "Visit approved!",
  VISIT_APPROVED_ERROR: "Error while approving visit!",
  VISIT_REJECTED_SUCCESS: "Visit rejected!",
  VISIT_REJECTED_ERROR: "Error while rejecting visit!",
  NAVIGATE_TO_MAPS_SUCCESS: "Navigating to Google Maps",
  NAVIGATE_TO_MAPS_ERROR: "We couldn’t find map coordinates for this address!",
  SERVICES_ADDED_SUCCESS: "Service added successfully!",
  SERVICES_ADDED_ERROR: "Error while adding service!",
  SERVICES_UPDATED_SUCCESS: "Service updated successfully!",
  SERVICES_UPDATED_ERROR: "Error while updating service!",
  SERVICES_DELETED_SUCCESS: "Service deleted successfully!",
  SERVICES_DELETED_ERROR: "Error while deleting service!",
  SERVICES_CREATED_SUCCESS: "Service created successfully!",
  SERVICES_CREATED_ERROR: "Error while creating service!",
  CARE_TEAM_MEMBER_ADDED_SUCCESS: "Team member added successfully",
  CARE_TEAM_MEMBER_ADDED_ERROR: "Error while adding team member!",
  CARE_TEAM_MEMBER_DELETED_SUCCESS: "Team member removed successfully",
  CARE_TEAM_MEMBER_DELETED_ERROR: "Error while removing team member!",
  ADD_EXISTING_WORKFORCE_TO_CARE_TEAM_SUCCESS: "Team member added successfully",
  ADD_EXISTING_WORKFORCE_TO_CARE_TEAM_ERROR: "Error while adding team member!",
  CREATE_VISIT_SUCCESS: "Visit created successfully!",
  CREATE_VISIT_ERROR: "Error while creating visit!",
  DELETE_JOURNAL_SUCCESS: "Journal deleted successfully",
  DELETE_JOURNAL_ERROR: "Error while deleting Journal",
  DELETE_ANNOUNCEMENT_SUCCESS: "Announcement deleted successfully",
  DELETE_ANNOUNCEMENT_ERROR: "Error while deleting Announcement",
  ADD_DASHBOARD_DATA_SUCCESS: "Settings saved successfully",
  ADD_DASHBOARD_DATA_ERROR: "Error while saving settings",
  INVITE_WORKFORCE_SUCCESS: "Invite sent to workforce",
  INVITE_WORKFORCE_ERROR: "Failed to invite workforce",
  UPDATE_WORKFORCE_SUCCESS: "Details updated successfully",
  UPDATE_WORKFORCE_ERROR: "Failed to update details",
  EMAIL_ALREADY_EXISTS: "Email address already exists",
  TELEPHONE_ALREADY_EXISTS: "Phone number already exists",
  MRN_ALREADY_EXISTS: "Medical record number already exists",
  REPORTING_LOG_NOTE: "To edit an item, please click on the box for the month you wish to edit and enter a new value. When done editing, click Save.",
  SELECT_FILTERS: "Click here to select filters",
  SELECT_REPORTS: "Select Existing Report:",
  SESSION_TIMEOUT: "Session Timeout",
  INACTIVE_LOGOUT_PROMPT: "You are about to be signed out due to inactivity. Please choose to stay signed in or sign out now. If no action is taken, you will be signed out automatically in {remainingTime} {seconds}.",
  TARGET_HOURS: "Target Hours",
  WAGE_PER_HOUR: "Wage Per Hour",
  MILEAGE: "Cost Per Miles",
  TIMEOUT_MINUTES: "Timeout Minutes",
  LOCK_TIMEOUT_MINUTES: "Lock Timeout Minutes",
  ABOUT_US:"About Us",
  ABOUT_US_DESCRIPTION:"The Patient Data Vault (PDV) was originally developed in 2008 to resolve common security issues associated  with sharing sensitive patient data electronically over the Internet. Since then, the PDV has evolved into a comprehensive HIPAA-compliant volunteer program management system for use in Hospice Care.",
  ABOUT_OUR_MISSION:"At PDV, our mission is to provide secure, efficient, and compassionate solutions for managing hospice volunteer programs. We strive to enhance the quality of care for patients and support for their families.",
  ABOUT_HIPPA:"Ensuring HIPAA-Compliant Communications for Hospices",
  FOOTER_DESCRIPTION:'In Collaboration with Hospice Volunteer Association',
  FOOTER_COPYRIGHT:'copyright 2005-2024 HEAL Project. All rights reserved',
  GENDER:'Gender',
  PPC:'Primary point of contact',
  FPC:'Financial point of contact',
  EDIT:'Edit',
  ADD:'Add',
  PATIENT:'Patient',
  WORKFORCE:'Workforce',
  TEAM_MEMBER:'Team Member',
  VIEW_FORM:"View Form",
  FILL_FORM:"Fill Form",
  ACCOUNT_ALREADY_REGISTERED: "Your account has been successfully created. To access your account, please log in using your credentials.",
  REGISTERED: "You're already registered!",
  ACCOUNT_REVOKED: "Your invitation has been revoked and is no longer active. Please contact your organization if you need a new invitation.",
  REVOKED: "Registration Unavailable",
  INVITATION_CODE_REQUIRED: "Invitation code is required!",
  INVALID_INVITATION: "This invitation link is invalid or has expired. Please contact your organization for a new invitation.",
  SIGNUP_SUCCESS: "Signup Successful",
  SIGNUP_SUCCESS_MESSAGE: "Thank you for Signing Up. Please click the login button to proceed to the login page.",
  CONFIRM_REPORT_DELETE: "Are you sure to delete this report?",
  CONFIRM: "Confirm",
  CANCEL: "Cancel",
  SET_PIN: "Set PIN",
  ENTER_PIN: "Enter PIN",
  UNLOCK: "Unlock",
  DELETE: "Delete",
  SAVE_AS_NEW: "Save As New",
  SAVE: "Save",
  SHARE_WITHOUT_NOTIFICATION: "Share without Notification",
  SEND_NOTIFICATION: "Send Notification",
  SEND: "Send",
  VIEW_PROFILE: "View Profile",
  WELCOME_TO_TEAM: "Welcome to the team {displayName}, Please add services to your profile to get started.",
  CURRENTLY_WORKING: "Are you currently working?",
  APPLIED_TO_VOLUNTEER: "Have you applied to volunteer at the hospice before?",
  REFERRAL: "How did you hear about us",
  YES: "Yes",
  NO: "No",
  STREET_ADDRESS: "Street Address",
  CITY: "City",
  COUNTRY:"Country",
  STATE: "State",
  ZIP: "Zip",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  EMAIL:"Email",
  PASSWORD:"Password",
  CONFIRM_PASSWORD:"Confirm Password",
  SIGNUP: "Sign up",
  SIGNOUT: "Sign out",
  KEEP_SIGN_IN: "Keep me signed in",
  COULD_NOT_SUBMIT: "Could not submit your details!",
  FIRST_NAME_ERROR_MESSAGE: "First name is required!",
  LAST_NAME_ERROR_MESSAGE: "Last name is required!",
  ADDRESS_ERROR_MESSAGE: "Address is required!",
  CITY_ERROR_MESSAGE: "City is required!",
  COUNTRY_ERROR_MESSAGE:"Country is required!",
  STATE_ERROR_MESSAGE: "State is required!",
  ZIP_ERROR_MESSAGE: "Zip is required!",
  PASSWORD_ERROR_MESSAGE: "Your password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character",
  CONFIRM_PASSWORD_ERROR_MESSAGE: "Password does not match",
  EMAIL_ERROR_MESSAGE: "Email is required!",
  VALID_EMAIL_ERROR_MESSAGE: "Enter valid email!",
  JOB_TITLE_ERROR_MESSAGE: "Role is required!",
  SUBMIT: "Submit",
  UPDATE_OPPORTUNITY_SUCCESS:"Volunteer request updated successfully",
  UPDATE_OPPORTUNITY_ERROR:"Could not update volunteer request",
  ACCEPT_OPPORTUNITY_SUCCESS:"Volunteer request accepted successfully",
  ACCEPT_OPPORTUNITY_ERROR:"Could not accept volunteer request",
  REJECT_OPPORTUNITY_SUCCESS:"Volunteer request rejected successfully",
  REJECT_OPPORTUNITY_ERROR:"Could not reject volunteer request",
  EMPLOYEE_CODE:"Employee Code",
  MRN_ERROR_MESSAGE:"Medical record number is required!",
  LOCATION_ERROR_MESSAGE:"Service location is required!",
  FACILITY_ERROR_MESSAGE:"Facility is required!",
  OFFICE_ERROR_MESSAGE:"Office is required!",
  VISIT_DELETE_SUCCESS:"Visit report deleted successfully!",
  VISIT_DELETE_ERROR:"Could not delete visit report",
  ORGANIZATION_ADD_SUCCESS:"Organization added successfully!",
  ORGANIZATION_ADD_ERROR:"Could not add organization",
  ORGANIZATION_UPDATE_SUCCESS:"Organization updated successfully",
  ORGANIZATION_UPDATE_ERROR:"Error while updating Organization",
  OUTDATED_DATA:"The request was updated. Please try again.",
  REQUEST_ACCEPTANCE_LIMIT_REACHED:"This volunteer request is no longer available!",
}